// @flow

import { connect } from 'react-redux';
import { Mutation } from 'react-apollo';
import React from 'react';
import { components } from '@peachjar/components';
import { get } from 'lodash';
import config from '../../../../config';
import ACTIVATE_DISTRICT_MUTATION from './ActivateDistrict.mutation';

const {
  Buttons: { ButtonPrimaryLarge },
  Notifications: { notifyError },
  LoadingIndicators: { Spinner },
} = components;

const CONVERTED_STATUS = 'converted';
const ERROR_ONBOARDING_SETUP_COULD_NOT_ACTIVATE_DISTRICT =
  'Uh oh! Looks like something went wrong while attempting to activate your district. Please contact support.';

type Props = {|
  +registrationId: string,
  +showActivationError: () => void,
|};

const GoLiveButton = ({ registrationId, showActivationError }: Props) => (
  <Mutation mutation={ACTIVATE_DISTRICT_MUTATION} onError={showActivationError}>
    {(doActivateDistrict, { data, loading, error }) => {
      if (get(data, 'activateDistrict.status') === CONVERTED_STATUS) {
        // redirect to geocore
        window.location.assign(config.REACT_APP_GEOCORE_LEGACY_APP_URL);
      }

      return (
        <ButtonPrimaryLarge
          data-testid="submit-onboarding-setup-activateDistrict"
          onClick={() =>
            doActivateDistrict({ variables: { input: { registrationId } } })
          }
          disabled={loading || error}
        >
          {loading && <Spinner />}Go Live
        </ButtonPrimaryLarge>
      );
    }}
  </Mutation>
);

const mapStateToProps = state => ({
  registrationId: state.user.registrationId,
});

const mapDispatchToProps = dispatch => ({
  showActivationError: () =>
    dispatch(notifyError(ERROR_ONBOARDING_SETUP_COULD_NOT_ACTIVATE_DISTRICT)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoLiveButton);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/go-live/components/GoLiveButton.jsx